import {CameraController} from "../cameraController.js";
import * as THREE from "three";

/**
 * A chasing camera controller
 */
export class CameraControllerChase extends CameraController {
    static DISTANCE = 7;
    static RAISE = new THREE.Vector3(0, 3, 0);

    /**
     * A ship chasing camera
     * @param {Camera} camera The camera to control
     */
    constructor(camera) {
        super(camera);
    }

    /**
     * Set the target for this camera controller
     * @param {CameraTargetable} target The target to track
     * @param {Track} track The track
     * @param {number} time The time interpolation in the range [0, 1]
     */
    setTarget(target, track, time) {
        this.camera.position.copy(target.getDirection(time)).multiplyScalar(-CameraControllerChase.DISTANCE).add(target.getPosition(time)).add(CameraControllerChase.RAISE);

        super.setTarget(target, track, time);
    }
}